<script lang="ts">
  import StarContainer from '~/calendar/StarContainer.svelte';
  import {
    getPuzzleKeyFromURL,
    isLatestDaily,
    latestDailyQuery,
    puzzleQuery,
  } from '~/lib/queries.svelte';
  import { prettyDate } from '~/utils/dates';
  import { puzzleSummaryModal } from '~/calendar/PuzzleSummary.svelte';
  import NavButton from '~/components/NavButton.svelte';
  import { gameOverModal } from './GameOver.svelte';
  import { page } from '$app/state';
  import { getGame } from '~/store/GameContext.svelte';
  import { DailyGame } from '~/store/daily.svelte';

  const game = $derived(getGame<DailyGame>().current);
  const latest = $derived(latestDailyQuery(game.variant));
  const isLatest = $derived(isLatestDaily(game, latest.data));
  const search = getPuzzleKeyFromURL(page);
  const puzzle = puzzleQuery(search);

  const handleOpenSummary = () => {
    // TODO is this right?
    if (game.lost) {
      gameOverModal.push();
    } else {
      puzzleSummaryModal.push(game.date);
    }
  };
</script>

<NavButton disabled={isLatest && !game.lost} onClick={handleOpenSummary}>
  {#if game.key}
    {game.key}
  {:else if game.date}
    {prettyDate(game.date)?.slice(0, -6)}
  {/if}
  {#if puzzle.data && (!isLatest || game.lost)}
    <StarContainer
      stars={puzzle.data.stars ?? 0}
      fullClear={puzzle.data?.fullClear ?? false}
    />
  {/if}
</NavButton>

<style lang="scss">
  @use '~/theme/include-media' as *;

  @include media('<=500px') {
    :global(.nav-button .star-container) {
      margin-top: 0.25em;
      margin-right: 0.5em;
    }
  }
</style>
